module.exports = __webpack_public_path__ + "teqbahn-assets/media/TeqitEcosystemOverview.85fd3d79.png";